import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  AuthRequestData,
  Permission,
  PermsES,
  RequestParam,
  ResponseData,
  TokenDecoded,
  User,
} from '@t-llevo/util';
import { Observable, map } from 'rxjs';
import { AuthBasicData } from '../models/auth-basic';
import { jwtDecode } from 'jwt-decode';
import { AuthBase } from './auth-base';

@Injectable()
export class AuthService extends AuthBase<User, AuthRequestData> {
  constructor(http: HttpClient) {
    super(http);
  }

  protected _transfom(input: AuthRequestData) {
    const decodeInfo = jwtDecode<TokenDecoded>(input.access_token);

    const rta: AuthBasicData<User> = {
      access: input.access_token,
      refresh: input.refresh_token,
      user: {
        id: '' /*decodeInfo.user_id*/,
        active: true /*decodeInfo.is_active*/,
        email: decodeInfo.email,
        role: 'ADMIN',
        username: 'admin' /*decodeInfo.username*/,
        user_permissions: [
          /*...decodeInfo.user_permissions*/
        ],
      },
    };
    return rta;
  }

  getAllPermission(reqInfo: RequestParam): Observable<Permission[]> {
    const { url, ...rest } = reqInfo;
    return this.http
      .get<ResponseData<Permission>>(url, rest)
      .pipe(map((elemt) => elemt.results));
  }
  /**
   * This method takes a list of `Permission` objects and groups them based on their `modelName` property.
   * It creates a `Map` where the keys are the `modelName` values and the values are arrays of `Permission` objects with the same `modelName`.
   * @param list A list of `Permission` objects.
   * @returns A `Map` object where the keys are the `modelName` values and the values are arrays of `Permission` objects with the same `modelName`.
   */
  groupPermissions(list: Permission[]): Map<string, Permission[]> {
    const tmpMap: Map<string, Permission[]> = new Map();
    list.forEach((elem) => {
      const tmpPerm = { ...elem };
      const dotIndex = elem.codename.indexOf('.');
      const underIndex = elem.codename.indexOf('_');
      //  const appName = elem.codename.substring(0, dotIndex);
      const modelName = elem.codename.substring(underIndex + 1);
      const permName = elem.codename.substring(dotIndex + 1, underIndex);
      const val = tmpMap.get(modelName);
      tmpPerm.name = PermsES[permName];
      if (val) {
        tmpMap.set(modelName, [...val, tmpPerm]);
      } else {
        tmpMap.set(modelName, [tmpPerm]);
      }
    });
    return tmpMap;
  }
}
